import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
} from '@mui/material';

export default function UnauthorizedAccess(props) {
    const handleClose = () => {
        props?.setOpen(false);
        window.location.href = '/login';
    };

    return (
        <Dialog
            open={props?.open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{'Alert'}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Unauthorized Access!
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
}
